import React from 'react'
import '../styles/LoadingOverlay.scss'

interface LoadingOverlayProps {
  isVisible: boolean
  message?: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = 'Loading...',
}) => {
  if (!isVisible) return null

  return (
    <div
      className="loading-overlay"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="loading-content">
        <div className="spinner" />
        <span className="loading-text">{message}</span>
      </div>
    </div>
  )
}
